export const EvaluationPlanConfiguration = {
    path: '/evaluation_plans_configuration',
    name: 'evaluation_plans_configuration',
    component: () => import('@/views/Evaluation/EvaluationConfiguration.vue'),
}